import React from 'react'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'

const RadioButton = (props) => {
    const icon = props.isExpanded
        ? <ChevronUp size={20} />
        : <ChevronDown size={20} />;

    // This is the main click handler on the wrapper div
    const localClickHandler = (e) => {
        // This handler should now only fire ONCE per click.
        if (props.onHeaderClick) {
            props.onHeaderClick(e);
        }
    };

    return (
        <div
            onClick={localClickHandler}
            style={{ cursor: 'pointer', padding: '0.75rem 1.25rem' }}
            className="w-100"
        >
            <div className="custom-control custom-radio">
                <input
                    id={props.usluga.idUsluge}
                    style={{ pointerEvents: 'none' }} // This is still useful
                    
                    // THE FIX: This stops the second, programmatic click caused by the label
                    onClick={(e) => e.stopPropagation()}

                    aria-checked={props.pickedUslugaId === props.usluga.idUsluge}
                    required
                    name="usluga"
                    type="radio"
                    className="custom-control-input"
                    value={props.usluga.idUsluge}
                    checked={props.pickedUslugaId === props.usluga.idUsluge}
                    readOnly
                />
                <label htmlFor={props.usluga.idUsluge} className="custom-control-label d-flex justify-content-between align-items-center">
                    <h6 className="cardTextHeader mb-0">{props.usluga.naziv}</h6>
                    {icon}
                </label>
            </div>
        </div>
    )
}

export default RadioButton